module.exports = __webpack_public_path__ + "static/img/step5.25e2f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/step5.png
// module id = 95XH
// module chunks = 0